/**
 * The visit's write-off lines (boona storage README; owner 2026-10-10): the list is the
 * colourist's formula, so the order matters and the same good may come twice - each is its own
 * line. A saved line carries its row id (goods_transaction_id) and keeps its row and place; a
 * new line gets a temporary id of its own and is written after the saved ones.
 */

let lastTempId = 0

/**
 * A temporary id for a new line: negative, so it never names a saved row, and unique in the
 * page. (Date.now() + a little random could repeat within a millisecond - a card adds several
 * lines at once - and then removing or editing one line hit both.)
 */
export function newLineId(): number {
  lastTempId -= 1
  return lastTempId
}

/** The list with `items` after the lines already there, in the order given. */
export function appendLines<T>(lines: T[], items: T[]): T[] {
  return [...lines, ...items]
}
